import React from 'react';
import { get, getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import PaymentViewSelector from 'views/payment-flow/payment-flow.selector';
import { useHistory } from 'react-router-dom';
import useFlashToggler from 'hooks/use-flash-toggler';
import { updateTotalValidOrdersAmount, updateUserPaymentViewAction } from './payment-flow.actions';
import loader from '__utils/loader-util';

export const PaymentFlowHelper = () => {
    const { userPaymentDetailView, totalValidOrdersAmount, loopBackURL } = propsToJS(useSelector(PaymentViewSelector));
    const history = useHistory();
    const dispatch = useDispatch();
    const flash = useFlashToggler();

    //bse payment api call, params: function to be called if call success,params like vpaid,paymntmode
    const makeBSEpayment = (paymentModeParams: any, callBackSuccess: Function) => {
        const userPaymentDetails = {
            user: userPaymentDetailView[ 0 ]?.loginId,
            orderDetailsList: userPaymentDetailView,
            totalAmount: totalValidOrdersAmount,
            loopBackUrl: loopBackURL,
            paymentUrl: userPaymentDetailView[ 0 ]?.paymentUrl,
            ...paymentModeParams
        }
        const orderNoParam = userPaymentDetails?.loopBackUrl?.split('?orderNo=')[1];
        post(ENDPOINTS.POST_MAKE_BSE_PAYMENT, userPaymentDetails, getDefaultHeaders(),true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.meta?.message === 'success') {
                    // loader.show();
                    callBackSuccess(response?.response?.data);
                }
                else {
                    history.push(`/payment-error?paymentUrl=${userPaymentDetailView[ 0 ]?.paymentUrl}&orderNo=${orderNoParam}`);
                }

            }, (error: AjaxError) => {
                history.push(`/payment-error?paymentUrl=${userPaymentDetailView[ 0 ]?.paymentUrl}&orderNo=${orderNoParam}`);
            });
    }

    //fetch order details and store in paymentview,validOrders,totalamount reducers
    const getBSEorderDetails = (successCallBack?: Function) => {
        get(ENDPOINTS.GET_ORDER_DETAILS,
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            if (response.status === 200)
            {
                if (response?.response?.data)
                {
                    if (successCallBack)
                    {
                        successCallBack(response?.response?.data)
                    }
                    else
                    {
                        if (response.response.data[ 0 ]?.paymentUrl)
                        {
                            const validOrders = response?.response?.data?.filter((order: any) => order.orderStatus === 'VALID');
                            if (validOrders?.length > 0)
                            {
                                dispatch(updateUserPaymentViewAction(validOrders));
                                let totalAmount = 0;
                                validOrders?.forEach((item: any) => totalAmount += item?.amount);
                                dispatch(updateTotalValidOrdersAmount(totalAmount));
                            }
                        } else flash.error(`This payment link has expired!`);
                    }
                }
                else flash.error(`No orders found!`);
            }
            else
            {
                flash.error("Something went wrong. Please try again later.")
            }
        }, (error: AjaxError) => {
            flash.error("Something went wrong. Please try again later.")
        });
    }



    return { makeBSEpayment, getBSEorderDetails };

}